// @flow
/* eslint-disable no-console */

import {isBrowser} from 'docs/util';
import * as Sentry from '@sentry/react';

export const logError = (error: Error) => {
  if (!isBrowser || /(dev\.stripe\.me)/.test(window.location.hostname)) {
    // Log the error to the console when testing locally
    console.error(error.message);
  } else if (Sentry && Sentry.captureException) {
    Sentry.captureException(error);
  }
};
